import { FC } from 'react'

import styled from 'styled-components'

import ErrorIcon from 'src/Assets/Svg/common/error.svg?react'

import { errorsList } from '../../helpers/errorsLIst'

const TextError = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.color.mediumRed};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

interface ErrorReflectionProps {
  text: string | string[]
}
export const ErrorReflection: FC<ErrorReflectionProps> = ({ text }) => {
  const textToString =
    typeof text === 'string'
      ? text
      : text.reduce((string, item) => string + item, '')

  if (!errorsList?.[textToString as keyof typeof errorsList]) {
    return (
      <TextError>
        <ErrorIcon />
        <div>{errorsList.default_error}</div>
      </TextError>
    )
  }
  return (
    <TextError>
      <ErrorIcon />
      <div>{errorsList[textToString as keyof typeof errorsList]}</div>
    </TextError>
  )
}
